import React, { useContext, useEffect, useState } from "react";
import Loader from "../../../../../components/Loader";
import { Popup } from "../../../../../components/Popup";
import { Box, Text } from "../../../../../designSystem";
import { get, post, patch } from "../../../../../lib/api";
import { calculateStringMatchScore, checkOverseasUser, contractObj, getTokenAndUid } from "../../../../../lib/utils";
import { AccountContext } from "../../../../../providers/accountProvider";
import { descriptionCard, descriptionText } from "../../../../Home/style";
import { BookAction, LeftContract } from "../../styles";
const descriptionTextBold = {
    ...descriptionText,
    fontWeight: 'bold'
}
const ContractModule = ({ bookDetails, setApplyContract }) => {
    const [ uiContractDetails, updateUIContractDetails] = useState(contractObj?.default)
    const [showContractModule,setShowContractModule] = useState(false)
    const [contractRes, setContractRes] = useState({})
    const [isContractLoding, setContractLoading] = useState(false)
    const [failedContractPopup, toggleFailedContractPopup] = useState(false)
    const { user } = useContext(AccountContext)
    const showContractDiv = !bookDetails?.is_disabled && bookDetails?.word_count >= 30000 && (bookDetails.status === 'approved' || bookDetails.status === 'published' || bookDetails.status === 'pending') 
                    && bookDetails?.program_type !== 'writer_benefit' && bookDetails?.sub_status !== 'open_for_withdrawal'
                    && (bookDetails.language === 'english' || bookDetails.language === 'tamil' || bookDetails.language === 'hindi') && !checkOverseasUser(user)

    const fetchContractDetail = (fullname) => {
        const { uid } = getTokenAndUid()
        get(`/contract/${bookDetails?.book_id}/?uid=${uid}&is_novel=1`).then((res) => {
          if(res.status === 'undertaker_pending' && bookDetails.application_status === 'ongoing'){
            updateUIContractDetails(contractObj?.confirmToSend)
            setShowContractModule(true)
          }
          else if(!res?.docket_id || res.status === 'failed'){
            setShowContractModule(false)
          }else{
            if(bookDetails?.sub_status === null || bookDetails?.sub_status === 'open_for_withdrawal' || bookDetails?.application_status === 'rejected') 
            { 
              setShowContractModule(false)
              return
            }
            setShowContractModule(true)
            // stringMatcher(fullname)
            if(res.status === 'undertaker_applied') updateUIContractDetails(contractObj?.undertakerApplied)
            else if(res.status === 'undertaker_signed') updateUIContractDetails(contractObj?.undertakerSigned)
            else if(res.status === 'success') updateUIContractDetails(contractObj?.success)
            else if(res.status === 'writer_signed') updateUIContractDetails(contractObj?.inReview)
            else updateUIContractDetails(contractObj?.signContract)
          }
          setContractRes(res)
        }).catch((err) => {
            setShowContractModule(false)
            console.log(err)
          // TODO: get this error code changed
        })
    }

    const handleCtaClick = () => {
      if(contractRes.status === 'writer_signed' || contractRes.status === 'undertaker_applied'){
        return;
      }
      if(!contractRes?.status) setApplyContract(true)
      else if(contractRes?.status === 'undertaker_pending'){
        const contractData = {
          uid : contractRes?.uid,
          book_id : bookDetails?.book_id,
          book_language: bookDetails?.language,
          author_name: bookDetails?.author_info?.fullname,
          email: user?.email,
          phone_number: (user?.phone_number)?.slice(3),
          is_guardian_flow: 1,
          address: contractRes?.props?.address,
          account_details: contractRes?.props?.account_details,
          guardian_account_details: contractRes?.props?.guardian_account_details,
        }
        setContractLoading(true)
        post('/contract/?is_novel=1', {data: contractData}).then((res) => {
          setContractLoading(false)
          fetchContractDetail()
        }).catch((err) => {
          setContractLoading(false)
          toggleFailedContractPopup(true)
          setShowContractModule(false)
        })
      }
      else signingContract()
    }

    const stringMatcher = (authorName) => {
        const { uid } = getTokenAndUid()
        get(`/user_api/user_bank_accounts/${uid}/?is_novel=1`).then(response => {
          const { account_name } = response?.result[0]
          const isStringMatched = calculateStringMatchScore(authorName,account_name)
          setShowContractModule(isStringMatched)
        })
    }

    const signingContract = () => {
        const { docket_id, application_id } = contractRes 
        let document_id = ''
        let signer_id = ''
        if(contractRes['signer_info']){
          document_id = contractRes['signer_info']['document_id']
          signer_id = contractRes['signer_info']['signer_id']
        }
        else{
          document_id = contractRes['document_id']
          signer_id = contractRes['signer_id']
        }
        const { uid } = getTokenAndUid()
    
        var clientData = {
          document_id, 
          signer_id, 
          docket_id, 
          id:application_id,
          widget_width:'100vw', 
          widget_height:'100vh', 
          
          getWidgetToken:function(token){
          // function will return widget token 
            const data = {
              widget_token : token,
            }
            post('/contract/process_esign_token?is_novel=1',{ data }).then((res) => {
              console.log("res",res)
            })
          },
          
          signatureStatus:function(result){
            console.log("status signature",result)
          // function will return signature status
          {contractRes?.status !==  "success" &&  patch(`/contract/${bookDetails?.book_id}/?uid=${uid}&is_novel=1`,{
              data : {
                reason : result.result,
                status: result.status === 'success' ? 'writer_signed' : result.status,
              }
            }).then(() => {
              if(result.status === 'success'){
                fetchContractDetail(bookDetails.author_info.fullname)
              }
            })}
            
          },
          
          errorLog:function(result){
          // function will return error }
          console.log("error",result)
          }
          }
          // function call to load Signature Panel 
          if(window.esignWidgetCall) window.esignWidgetCall(clientData);
    }

    useEffect(() => {
        if(bookDetails?.application_status) fetchContractDetail()
        else if(showContractDiv) setShowContractModule(true)
    },[bookDetails])

    
    return (
        <>
          <Popup
            show={failedContractPopup}
            close={() => toggleFailedContractPopup(false)}
            className="role-assignment"
            renderActions={(
              <>
                <button
                  className='action-button primary'
                  type='button'
                  onClick={() => toggleFailedContractPopup(false)}
                >
                  Okay
                </button>
              </>
            )}
          >
            <div className="form-error">
              <span className="title">
                   Some declared information seems to be incorrect, our team will reach out to you within 7 working days
              </span>
            </div>
          </Popup> 
          {showContractDiv && showContractModule && (
              <Box variant="flexCard" flexDirection={["column", "row"]} mb="8px">
                  <LeftContract>
                      <Text variant="heading" mb="8px">{uiContractDetails?.heading}</Text>
                      <Text>
                          {uiContractDetails?.subHeading}
                      </Text>
                      <BookAction enabled onClick={handleCtaClick}>
                          {isContractLoding ? <Loader invertColor inline size="md"/> :  uiContractDetails?.ctaTitle}
                      </BookAction>
                      <Box {...descriptionCard}>
                          <Text {...descriptionTextBold}>
                              {uiContractDetails?.cautionNote}
                          </Text>
                      </Box>
                  </LeftContract>
              </Box>)}
        </>
    )
}

export default ContractModule